import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ORDERRECEIVERECEIPTBLOCK_LEGACY_FIELD_ORDER = [
  'display',
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  orderReceiveReceiptBlockDescriptor: _generatedOrderReceiveReceiptBlockDescriptor,
  orderReceiveReceiptBlockBlocDefinition,
  orderReceiveReceiptBlockDashboardLayout,
  orderReceiveReceiptBlockConfig,
  orderReceiveReceiptBlockResolveConfig,
  orderReceiveReceiptBlockProperties,
} = doodBlockConfig(
  {
    name: "Order - Receive receipt",
    componentType: 'OrderReceiveReceiptBlockComponent',
    category: 'content',
    description: "Order - Receive receipt.",
    keywords: [],
    allowedIn: [
      { bloc: 'OrderStatusPageComponent', slot: '*' },
    ],


    sharedFields: {}
  },

  () => ({
    display: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: 'pages.blocks.order-receive-receipt.display.label',
        default: true,
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: 'pages.blocks.order-receive-receipt.tab.content.label',
        fieldsets: [
          {
            legend: 'pages.blocks.order-receive-receipt.fieldset.visibility.label',
            fields: ['display'],
          },
        ],
      },
    ],
  })
);

export function orderReceiveReceiptBlockDescriptor(): IBlockDescriptor;
export function orderReceiveReceiptBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function orderReceiveReceiptBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedOrderReceiveReceiptBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedOrderReceiveReceiptBlockDescriptor, orderReceiveReceiptBlockProperties, fieldOrder);
}

export {
  orderReceiveReceiptBlockBlocDefinition,
  orderReceiveReceiptBlockDashboardLayout,
  orderReceiveReceiptBlockProperties,
  orderReceiveReceiptBlockConfig,
  orderReceiveReceiptBlockResolveConfig,
};

export type OrderReceiveReceiptBlockConfig = typeof orderReceiveReceiptBlockConfig;
